/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-card[_ngcontent-%COMP%]{text-align:center}.mat-card-header[_ngcontent-%COMP%]{justify-content:center}h2[_ngcontent-%COMP%]{padding-bottom:20px;font-size:1.6em}.error-text[_ngcontent-%COMP%]{padding-bottom:10px;font-size:1.2em;line-height:1.5em}"];
export { styles as styles };
